const initialState = {
  userInfo: {
    fullName: 'Test Elek',
    email: 'test@elek.hu',
    activeTenantId: null as string | null,
    platformPermissions: [] as string[],
    tenantPermissions: [] as string[],
    hasTenantMembership: false,
    authorityInfo: {
      groups: [],
      permissions: [],
      roles: [],
    },
  },
};

export const userReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'LOAD_USER_INFO': {
      const payload = action.payload ?? {};
      return {
        ...state,
        userInfo: {
          ...payload,
          platformPermissions:
            payload.platformPermissions ?? payload.PlatformPermissions ?? [],
          tenantPermissions:
            payload.tenantPermissions ?? payload.TenantPermissions ?? [],
          hasTenantMembership: !!(
            payload.hasTenantMembership ??
            payload.HasTenantMembership ??
            false
          ),
          activeTenantId:
            payload.activeTenantId ?? payload.ActiveTenantId ?? null,
          authorityInfo: payload.authorityInfo ??
            payload.AuthorityInfo ?? {
              groups: [],
              permissions: [],
              roles: [],
            },
        },
      };
    }
    default:
      return state;
  }
};
